import moment from "moment";

/** An email log time, in UTC and labelled, as the API records it and the server logs show it. */
export function formatEmailLogInstant(value: Date): string {
  return moment.utc(value).format("YYYY-MM-DD HH:mm:ss [UTC]");
}

/**
 * The instant a date field's day begins, in UTC, or undefined for an empty or invalid field.
 * `daysLater` moves it, so a "to" day can be sent as the exclusive start of the next day.
 */
export function startOfUtcDay(value: string, daysLater = 0): Date | undefined {
  if (!value) return undefined;
  const day = moment.utc(value, "YYYY-MM-DD", true);
  if (!day.isValid()) return undefined;
  return day.add(daysLater, "days").toDate();
}
